import React, { Fragment, useState } from 'react';
import {
  Button,
  Modal,
  Form,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { post } from '../../../services/back.service';

function ModalFormPqrResponse({
  pqrId,
  callback,
  title,
  button_text,
  button_variant = 'primary',
}) {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');

  const handleClose = () => {
    setShow(false);
    setMessage('');
  };

  const handleShow = () => {
    setShow(true);
  };

  const saveForm = async (e) => {
    if (!message.trim()) return;

    const body = { message: message.trim() };
    const respo = await post('/pqr/' + pqrId + '/responses/create', body);

    if (respo.success) {
      callback('success', 'Respuesta agregada correctamente');
    } else {
      callback('danger', respo.message);
    }
    handleClose();
  };

  return (
    <Fragment>
      <Button variant={button_variant} onClick={handleShow}>
        {button_text}
      </Button>

      <Modal animation={false} fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form.Label htmlFor="message">Mensaje</Form.Label>
            <Form.Control
              className="mb-4"
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              as="textarea"
              rows={5}
              placeholder="Escriba su respuesta..."
            />
            <Row className="text-center mb-2">
              <Col className="buttons-container">
                <Button variant="secondary" onClick={handleClose}>
                  Cancelar
                </Button>
                <Button
                  type="submit"
                  variant="primary"
                  onClick={saveForm}
                  disabled={!message.trim()}
                >
                  Enviar Respuesta
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalFormPqrResponse;
